import { NgClass } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  input,
  inject,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CommonService ,ToastMessageService} from '@fitness-force/api';
import { AutomationEventType, AutomationScheduleType, AutomationTimings } from '@fitness-force/enum';
import type { AutomationMaster } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'automation-schedule-type',
  templateUrl: './automation-schedule-type.component.html',
  styleUrls: ['./automation-schedule-type.component.css'],
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    ButtonModule,
    TranslateModule,
    MessageModule,
    NgClass,
  ],
})
export class AutomationScheduleTypeComponent implements OnInit {
  private readonly commonService = inject(CommonService);
  private readonly translateService = inject(TranslateService);
  cd = inject(ChangeDetectorRef);

  readonly automationMaster = input(
    new BehaviorSubject<AutomationMaster>({} as AutomationMaster),
  );
  readonly formGroup = input<UntypedFormGroup>(new UntypedFormGroup({}));
  readonly controlName = input<UntypedFormControl>(new UntypedFormControl());
  readonly scheduleInMin = input<number>(0);
  readonly type = input<string>('EMAIL');

  automationTimingOptions: any;
  automationScheduleTypes: { key: string; value: string }[] = [];

  sendMessageOptions: any = [];
  selectedSendMessageOption: string | null = null;
  showDefaultMessage: boolean = false;

  constructor() {
    this.sendMessageOptions = ['After', 'Before', 'OnEvent'];
  }

  ngOnInit() {
    const automationMaster = this.automationMaster();
    if (automationMaster.value) {
      if (
        automationMaster.value.automation_schedule_type &&
        (automationMaster.value.automation_schedule_type ==
          AutomationScheduleType.Day ||
          automationMaster.value.automation_schedule_type.toString() ==
            AutomationScheduleType[AutomationScheduleType.Day])
      ) {
        this.automationScheduleTypes.push({
          key: AutomationScheduleType[AutomationScheduleType.Day],
          value: AutomationScheduleType[AutomationScheduleType.Day],
        });
      } else if (
        automationMaster.value.automation_schedule_type &&
        (automationMaster.value.automation_schedule_type ==
          AutomationScheduleType.Hour ||
          automationMaster.value.automation_schedule_type.toString() ==
            AutomationScheduleType[AutomationScheduleType.Hour])
      ) {
        this.automationScheduleTypes.push(
          {
            key: AutomationScheduleType[AutomationScheduleType.Day],
            value: AutomationScheduleType[AutomationScheduleType.Day],
          },
          {
            key: AutomationScheduleType[AutomationScheduleType.Hour],
            value: AutomationScheduleType[AutomationScheduleType.Hour],
          },
        );
      } else {
        this.automationScheduleTypes.push(
          {
            key: AutomationScheduleType[AutomationScheduleType.Day],
            value: AutomationScheduleType[AutomationScheduleType.Day],
          },
          {
            key: AutomationScheduleType[AutomationScheduleType.Hour],
            value: AutomationScheduleType[AutomationScheduleType.Hour],
          },
          {
            key: AutomationScheduleType[AutomationScheduleType.Minute],
            value: AutomationScheduleType[AutomationScheduleType.Minute],
          },
        );
      }
      if (
        this.SelectedAutomationTimingFormControl.value == '' &&
        this.SelectedAutomationScheduleTypeFormControl.value == ''
      ) {
        if (this.isBackendAutomation()) {
          this.SelectedAutomationScheduleTypeFormControl.clearValidators();
          this.SelectedAutomationTimingTypeFormControl.clearValidators();
          this.SelectedAutomationTimingTypeFormControl.setValue(
            'System Default',
          );
          this.selectedSendMessageOption = 'System Default';
          this.SelectedAutomationTimingFormControl.clearValidators();
          this.showDefaultMessage = true;
        } else {
          const timing = automationMaster.value.automation_timings.find(
            (timing) =>
              timing != AutomationTimings[AutomationTimings.NonAutomation],
          );
          this.SelectedAutomationTimingTypeFormControl.setValue(timing);
          if (timing == 'Immediate' || timing == 'SameDay') {
            this.selectedSendMessageOption = 'OnEvent';
          } else {
            this.selectedSendMessageOption = timing!;
          }
          this.SelectedAutomationTimingTypeFormControl.setValidators(
            Validators.required,
          );
          this.showDefaultMessage = false;
        }

        if (
          automationMaster.value.automation_schedule_type ==
            AutomationScheduleType.Day ||
          automationMaster.value.automation_schedule_type.toString() ==
            AutomationScheduleType[AutomationScheduleType.Day]
        ) {
          this.SelectedAutomationScheduleTypeFormControl.setValue(
            this.automationScheduleTypes[0],
          );
          this.SelectedAutomationTimingFormControl.setValidators(
            this.isBackendAutomation() ? null : Validators.required,
          );
          this.setAutomationData();
        } else {
          this.SelectedAutomationScheduleTypeFormControl.setValidators(
            this.isBackendAutomation() ? null : Validators.required,
          );
        }

        if (
          this.SelectedAutomationTimingTypeFormControl.value === 'Immediate' ||
          this.SelectedAutomationTimingTypeFormControl.value === 'SameDay'
        ) {

          console.log(this.automationMaster().value);
          this.SelectedAutomationTimingFormControl.setValidators(
            this.isBackendAutomation() ? null : Validators.required,
          );
          this.SelectedAutomationScheduleTypeFormControl.disable();
          this.SelectedAutomationTimingFormControl.disable();
        } else {
          this.SelectedAutomationScheduleTypeFormControl.enable();
          this.SelectedAutomationTimingFormControl.enable();
        }
      } else {
        this.setAutomationData();
      }
    }

    this.SelectedAutomationTimingTypeFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.selectedSendMessageOption = value;
          this.cd.detectChanges();
          this.setAutomationData();

          if ((value === 'Immediate' || value === 'SameDay') && !this.isMileStoneAutomation()) {
            this.SelectedAutomationTimingFormControl.setValidators(
              Validators.required,
            );
            this.SelectedAutomationScheduleTypeFormControl.disable();
            this.SelectedAutomationTimingFormControl.disable();
          } else {
            this.SelectedAutomationScheduleTypeFormControl.enable();
            this.SelectedAutomationTimingFormControl.enable();
          }
        }
      });

    this.SelectedAutomationScheduleTypeFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          // Clear the previously selected timing option since the options list is now different
          this.SelectedAutomationTimingFormControl.setValue(null, {
            emitEvent: false,
          });
          this.setAutomationData();
          this.cd.detectChanges();
        }
      });
  }

  setAutomationData() {
    let timing: string = '';
    this.translateService
      .get('AUTOMATION.EVENT.' + this.automationMaster().value.automation_type)
      .subscribe((translation) => {
        timing = `(${this.SelectedAutomationTimingTypeFormControl.value} ${translation})`;
      });

    // Use the currently selected schedule type from the dropdown if available,
    // otherwise fall back to the automation master's default schedule type.
    const selectedScheduleTypeFormValue = this.SelectedAutomationScheduleTypeFormControl.value;
    let scheduletype: AutomationScheduleType;
    if (selectedScheduleTypeFormValue?.value) {
      scheduletype =
        AutomationScheduleType[
          selectedScheduleTypeFormValue.value as keyof typeof AutomationScheduleType
        ];
    } else {
      scheduletype =
        AutomationScheduleType[
          this.automationMaster().value.automation_schedule_type.toString() as keyof typeof AutomationScheduleType
        ];
    }

    const eventType =
      AutomationTimings[
        this.SelectedAutomationTimingTypeFormControl.value.toString() as keyof typeof AutomationTimings
      ];
    this.automationTimingOptions = this.commonService.createKeyValueArray(
      scheduletype,
      timing,
      eventType,
    );
    if (this.isBackendAutomation()) {
      this.SelectedAutomationScheduleTypeFormControl.clearValidators();
      this.SelectedAutomationTimingTypeFormControl.clearValidators();
      this.SelectedAutomationTimingFormControl.clearValidators();
      this.showDefaultMessage = true;
    } else {
      const timingOption =
        this.automationMaster().value.automation_timings.find(
          (timing) =>
            timing != AutomationTimings[AutomationTimings.NonAutomation],
        );
      this.SelectedAutomationTimingTypeFormControl.setValidators(
        Validators.required,
      );
      this.showDefaultMessage = false;
    }
  }

  selectSendMessageOption(option: string): void {
    if (option == 'OnEvent') {
      option = this.automationMaster().value.automation_timings.find(
        (timing) => timing == 'Immediate' || timing == 'SameDay',
      ) ?? '';
    }
    this.selectedSendMessageOption = option;
    this.SelectedAutomationTimingTypeFormControl.setValue(option, {
      emitEvent: true,
    });
    if ((option === 'Immediate' || option === 'SameDay') && !this.isMileStoneAutomation()) {
      this.SelectedAutomationTimingFormControl.setValidators(
        Validators.required,
      );
      this.SelectedAutomationScheduleTypeFormControl.disable();
      this.SelectedAutomationTimingFormControl.disable();
    } else {
      this.SelectedAutomationScheduleTypeFormControl.enable();
      this.SelectedAutomationTimingFormControl.enable();
    }
    this.cd.detectChanges();
  }

  get SelectedAutomationTimingTypeFormControl() {
    return this.formGroup().controls[
      'automation_timings_type'
    ] as UntypedFormControl;
  }

  get SelectedAutomationTimingFormControl() {
    return this.formGroup().controls['automation_timing'] as UntypedFormControl;
  }

  get SelectedAutomationScheduleTypeFormControl() {
    return this.formGroup().controls[
      'automation_schedule_type'
    ] as UntypedFormControl;
  }

  isBackendAutomation(): boolean {
    const automationMaster = this.automationMaster();
    return (
      automationMaster.value.automation_timings.length == 1 &&
      (automationMaster.value.automation_timings.includes(
        AutomationTimings[AutomationTimings.NonAutomation],
      ) ||
        automationMaster.value.automation_timings.includes(
          AutomationTimings[AutomationTimings.BackendImmedidate],
        ) ||
        automationMaster.value.automation_timings.includes(
          AutomationTimings[AutomationTimings.BackendNonImmedidate],
        ))
    );
  }

  isMileStoneAutomation(): boolean {
    return this.automationMaster().value.automation_type == AutomationEventType.auto_clt_milestone_achieved || this.automationMaster().value.automation_type.toString() == AutomationEventType[AutomationEventType.auto_clt_milestone_achieved];
  }

  checkHaveSameDayOrImmediate(option: string): boolean {
    if (option == 'OnEvent') {
      const automationMaster = this.automationMaster();
      return (
        automationMaster.value.automation_timings.includes('Immediate') ||
        automationMaster.value.automation_timings.includes('SameDay')
      );
    } else {
      return this.automationMaster().value.automation_timings.includes(option);
    }
  }
}
